import {z} from 'zod';

import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {DepositMethodName} from '../types/DepositMethodName';
import {DepositMethodFormValues} from './depositMethodSchema';

export const validateDepositMethodFields = (
  method: DepositMethodName,
  payment: DepositMethodFormValues,
  ctx: z.RefinementCtx
) => {
  if (!payment.isAllowed) {
    return;
  }

  const requiredMessage = i18n.t('errors.field_is_required');

  const addRequiredIssue = (path: string[], value: string | Nullish) => {
    if (isNilOrEmpty(value)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [method, ...path],
        message: requiredMessage,
      });
    }
  };

  addRequiredIssue(['taxDocument', 'templateId'], payment.taxDocument?.templateId);
  addRequiredIssue(['taxDocument', 'docSeriesId'], payment.taxDocument?.docSeriesId);
  addRequiredIssue(['taxDocumentEu', 'docSeriesId'], payment.taxDocumentEu?.docSeriesId);
  addRequiredIssue(
    ['taxDocumentOutsideEu', 'docSeriesId'],
    payment.taxDocumentOutsideEu?.docSeriesId
  );
  addRequiredIssue(
    ['taxDocumentCorrection', 'docSeriesId'],
    payment.taxDocumentCorrection?.docSeriesId
  );
  addRequiredIssue(
    ['taxDocumentCorrectionEu', 'docSeriesId'],
    payment.taxDocumentCorrectionEu?.docSeriesId
  );
  addRequiredIssue(
    ['taxDocumentCorrectionOutsideEu', 'docSeriesId'],
    payment.taxDocumentCorrectionOutsideEu?.docSeriesId
  );
};
